import { importProject } from "queries/project";

export const useImportProject = () => {
  return ({
    owner,
    repo,
    workspaceId,
  }: {
    owner: string;
    repo: string;
    workspaceId: string;
  }) => importProject({ owner, repo, workspaceId });
};
